"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInstantiationService = exports.IInstantiationHookPoint = void 0;
var legacy_deps_1 = require("./legacy-deps");
// eslint-disable-next-line no-shadow
var IInstantiationHookPoint;
(function (IInstantiationHookPoint) {
    IInstantiationHookPoint[IInstantiationHookPoint["POST_CONSTRUCTOR"] = 0] = "POST_CONSTRUCTOR";
})(IInstantiationHookPoint = exports.IInstantiationHookPoint || (exports.IInstantiationHookPoint = {}));
exports.IInstantiationService = legacy_deps_1.createDecorator('IInstantiationService');
//# sourceMappingURL=instantiation.js.map